import { resolveWallTime } from "../../event-experience/agenda-schedule";
import { SEND_PRECISION } from "../scheduled-announcements";
import { clockName, COMPLETE, describeWall } from "../WallTimeField";
import { WarningNote } from "./WarningNote";

/**
 * Which clock a send time is typed on, how precise the send is, and a
 * warning for a time the clocks pass twice, which would otherwise be booked
 * silently as the first pass.
 */
export function SendTimeNote({
  timeZone,
  wall,
  testId,
}: {
  timeZone: string | undefined;
  wall: string;
  testId: string;
}) {
  const repeated =
    COMPLETE.test(wall) && resolveWallTime(wall, timeZone).kind === "repeated";
  return (
    <div className="space-y-1 text-xs text-muted-foreground">
      <p data-testid={testId}>
        {timeZone
          ? `Enter the time in ${clockName(timeZone)} (${timeZone}), the event's time zone. `
          : "Enter the time on your device's clock; the event has no time zone this browser knows. "}
        {SEND_PRECISION}
      </p>
      {repeated && (
        <WarningNote testId={`${testId}-repeated`}>
          {describeWall(wall)} happens twice in {clockName(timeZone)}, because
          the clocks go back that night. The first one, before the change, is
          used.
        </WarningNote>
      )}
    </div>
  );
}
